import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import ProgressBar from "../../../utils/progressBar/ProgressBar";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  FormLabel,
  Heading,
} from "@chakra-ui/react";
import ReactQuill from "react-quill";
import { Box, Input, Image } from "@chakra-ui/react";
import "react-quill/dist/quill.snow.css";
import { Trash2 } from "lucide-react";

const initialFormData = {
  title: "",
  aadhaarCard: "",
  photo: "",
  registry: "",
  electricityBill: "",
  cancelCheque: "",
  mobileNo: "",
  emailId: "",
  items: [
    { document: "Aadhaar Card" },
    { document: "Photo" },
    { document: "Registry/House Tax/Full Payment Agreement" },
    { document: "Electricity Bill" },
    { document: "Cancel Cheque/Bank Passbook" }
  ],
  guidelines: "",
  note: "",
  contactDetails: "",
  bankDetail: "",
};

function DocumentsForm(props) {
  const {
    isUpdateMode,
    dataToEdit,
    setIsUpdateMode,
    documentsId,
    onNewDataAdded,
  } = props;
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const [qrImage, setQrImage] = useState(null);

  const addRow = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      items: [...prevFormData.items, { document: "", files: null, fileName: "", fileUrl: "" }],
    }));
  };

  const deleteRow = (e, index) => {
    e.preventDefault();
    setFormData((prevFormData) => ({
      ...prevFormData,
      items: prevFormData.items.filter((_, i) => i !== index),
    }));
  };

  const handleFileUpload = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        items: prevFormData.items.map((item, i) =>
          i === index ? { ...item, files: file } : item
        ),
      }));
    }
  };

  useEffect(() => {
    if (isUpdateMode && dataToEdit) {
      setFormData(dataToEdit);
    } else {
      setFormData(initialFormData);
    }
  }, [isUpdateMode, dataToEdit]);

  const handleOnClose = () => {
    props.closeDrawer();
    setIsUpdateMode(false);
    setFormData(initialFormData);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowProgressBar(true);
    // Mock add
    setTimeout(() => {
      toast.success("Document added successfully!");
      handleOnClose();
      onNewDataAdded();
      setShowProgressBar(false);
    }, 1000);
  };

  const handleOnUpdate = (e) => {
    e.preventDefault();
    setShowProgressBar(true);
    // Mock update
    setTimeout(() => {
      toast.success("Document updated successfully!");
      handleOnClose();
      setShowProgressBar(false);
    }, 1000);
  };

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imgUrl = URL.createObjectURL(file);
      setQrImage(imgUrl);
    }
  };

  const handleChange = (value, name) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  return (
    <Drawer
      isOpen={props.isDrawerOpen}
      placement="right"
      size="xl"
      onClose={handleOnClose}
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>
          {isUpdateMode ? "Update Document" : "Create Document"}
        </DrawerHeader>
        <DrawerBody>
          {showProgressBar && <ProgressBar colorScheme="pink" />}
          <form onSubmit={isUpdateMode ? handleOnUpdate : handleSubmit}>
            <div className="card">
              <div className="card-body">
                {/* <div className='mb-4'>
                  <Heading size="md" mb={3}>Basic Information</Heading>
                  <div className='row'>
                    <div className='col-lg-12 col-md-12 col-sm-12 mb-2'>
                      <input
                        type='text'
                        className='form-control'
                        placeholder='Title'
                        name='title'
                        value={formData?.title}
                        onChange={(e) => handleChange(e.target.value, 'title')}
                        required
                      />
                      <FormLabel className="small-label ps-3">Title</FormLabel>
                    </div>
                  </div>
                </div> */}
                
                <div className="mb-4">
                   <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 mb-2">
                      <div className="card-body">
                        <h6 className="card-title">Document </h6>
                        <div style={{ width: "100%" }}>
                          <table className="table-class" style={{ marginBottom: "50px" }}>
                            <thead>
                              <tr>
                                <th colSpan={9}>
                                  <h5 style={{ fontSize: "15px" }}>Item Table</h5>
                                </th>
                              </tr>
                              <tr className="border">
                                <th className="border" style={{ width: "10%" }}>
                                  ACTION
                                </th>
                                <th className="border" style={{ width: "20%" }}>
                                  Document
                                </th>
                            

                              </tr>
                            </thead>
                            <tbody>
                              {formData?.items?.map((row, index) => (
                                <tr key={index}>
                                  <td className="border text-center table-class" style={{ width: "50px" }}>
                                    <button onClick={(e) => deleteRow(e, index)} className="delete-button">
                                      <Trash2 size={16} color="#dd0b58" />
                                    </button>
                                  </td>

                                  <td className="border" style={{ minWidth: "200px" }}>
                                    <input
                                      type="text"
                                      className="form-control p-2"
                                      name="document"
                                      value={row.document}
                                      onChange={(e) => {
                                        setFormData((prevFormData) => ({
                                          ...prevFormData,
                                          items: prevFormData.items.map((item, i) => (i === index ? { ...item, document: e.target.value } : item)),
                                        }));
                                      }}
                                    />
                                  </td>



                                </tr>
                              ))}
                          <tr>
                            <td colSpan={2}>
                              <div className="ps-4 mt-2" style={{ textAlign: "left" }}>
                                <button type="button" style={{ outline: "none" }} onClick={addRow}>
                                  + Add row
                                </button>
                              </div>
                            </td>
                          </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 mb-2">
                      <FormLabel className="small-label ps-3">
                        Document
                      </FormLabel>
                      <ReactQuill
                        theme="snow"
                        value={formData?.document}
                        onChange={(value) => handleChange(value, "document")}
                        modules={modules}
                        formats={formats}
                        placeholder="Enter document content"
                      />
                    </div>
                  </div> */}
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 mb-2">
                      <FormLabel className="small-label ps-3">
                        Guidelines
                      </FormLabel>
                      <ReactQuill
                        theme="snow"
                        value={formData?.guidelines}
                        onChange={(value) => handleChange(value, "guidelines")}
                        modules={modules}
                        formats={formats}
                        placeholder="Enter guidelines"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 mb-2">
                      <FormLabel className="small-label ps-3">Note</FormLabel>
                      <ReactQuill
                        theme="snow"
                        value={formData?.note}
                        onChange={(value) => handleChange(value, "note")}
                        modules={modules}
                        formats={formats}
                        placeholder="Enter note"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 mb-2">
                      <FormLabel className="small-label ps-3">
                        Contact Details for Respective Department
                      </FormLabel>
                      <ReactQuill
                        theme="snow"
                        value={formData?.contactDetails}
                        onChange={(value) =>
                          handleChange(value, "contactDetails")
                        }
                        modules={modules}
                        formats={formats}
                        placeholder="Enter contact details for respective department"
                      />
                    </div>
                  </div>
                 
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 mb-2">
                      <div className="border rounded-md p-1 shadow-md mt-4">
                        {/* Title */}
                        <div className="text-center fw-bold py-2 border bg-primary text-white">
                          Online Payment Details
                        </div>

                        {/* Table */}
                        <table className="table table-bordered text-center align-middle">
                          <thead className="table-light">
                            <tr>
                              <th>Bank Details</th>
                              <th>G Pay No.</th>
                              <th>UPI ID</th>
                              <th>Scanner</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr>
                              {/* Empty Bank Details */}
                              <td>
                                <div className="fw-bold">
                                  Bank Account Name :
                                </div>
                                <div className="fw-bold">Bank Name :</div>
                                <div className="fw-bold">Acc No. :</div>
                                <div className="fw-bold">IFSC Code :</div>
                              </td>

                              {/* Empty GPay */}
                              <td></td>

                              {/* Empty UPI */}
                              <td></td>

                              {/* QR Code Preview */}
                              <td style={{ width: "180px" }}>
                                {qrImage ? (
                                  <Image
                                    src={qrImage}
                                    alt="Uploaded QR"
                                    border="1px solid #ccc"
                                    borderRadius="6"
                                    p="1"
                                    boxSize="150px"
                                    objectFit="cover"
                                    margin="auto"
                                  />
                                ) : (
                                  <div
                                    style={{
                                      width: "150px",
                                      height: "150px",
                                      border: "1px dashed gray",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      margin: "auto",
                                      borderRadius: "6px",
                                      color: "#777",
                                    }}
                                  >
                                    QR Image Here
                                  </div>
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        {/* Upload Button */}
                        <div className="text-center mt-3">
                          <label className="btn btn-primary">
                            Upload Scanner Image
                            <Input
                              type="file"
                              display="none"
                              accept="image/*"
                              onChange={handleUpload}
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </DrawerBody>
        <DrawerFooter>
          <div className="gap-3 d-flex justify-content-center w-full mx-auto ">
            <button
              type="button"
              className="cancel-button"
              onClick={handleOnClose}
            >
              Cancel
            </button>
            <button
              className="create-button"
              onClick={(e) => {
                !isUpdateMode ? handleSubmit(e) : handleOnUpdate(e);
              }}
            >
              {isUpdateMode ? "Update" : "Submit"}
            </button>
          </div>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}

export default DocumentsForm;
